<template>
  <FlyConfirmationModal
    :title="title"
    :ok-btn-props="BUTTON_VARIANTS_ENUM.DANGER"
    :ok-btn-text="okBtnText"
    @close="onClose"
    @confirm="onConfirm"
  >
    <FlyBox
      flex-direction="column"
      padding-horizontal="6"
      padding-top="3"
      padding-bottom="8"
      width="full"
    >
    </FlyBox>
  </FlyConfirmationModal>
</template>

<script>
import FlyConfirmationModal from 'shared/components/Modal/FlyConfirmationModal';
import { mapActions, mapMutations } from 'vuex';
import { closeModal } from 'shared/store/modal/modalMutationTypes';
import { CONFIRM_ARCHIVE_PIPELINE_MODAL } from 'web/modal/modalKeys';
import FlyBox from 'shared/components/Grid/FlyBox.vue';
import FormStoreMixin from 'shared/stores/form/FormStoreMixin.js';
import { CONFIRM_ARCHIVE_PIPELINE_FORM } from 'web/form/formKeys.js';
import { changePipelineStatusAction } from 'web/pipelines/pipelinesActionTypes';
import TOAST_TYPE_ENUM from 'shared/components/Toast/TOAST_TYPE_ENUM';
import { showToastAction } from 'shared/stores/toast/toastActionTypes';
import { get } from 'lodash';
import VueTypes from 'vue-types';

export default {
  name: 'ArchivePipelineConfirmModal',
  components: {
    FlyConfirmationModal,
    // FlyText,
    FlyBox,
  },
  mixins: [FormStoreMixin(CONFIRM_ARCHIVE_PIPELINE_FORM)],
  props: {
    pipeline: VueTypes.object.isRequired,
  },
  emits: ['save'],
  computed: {
    formData() {
      return this.getFormData(CONFIRM_ARCHIVE_PIPELINE_FORM);
    },
    pipelineId() {
      return get(this.pipeline, 'id');
    },
    title() {
      return `Are you sure to ${this.key} ${this.pipeline.name} pipeline?`;
    },
    okBtnText() {
      return 'Yes';
    },
    toastTitle() {
      return {
        stop: {
          progress: 'Stopping pipeline',
          success: 'Pipeline stopped',
        },
        start: {
          progress: 'Starting pipeline',
          success: 'Pipeline started',
        },
        archive: {
          progress: 'Archiving pipeline',
          success: 'Pipeline archived',
        },
      };
    },
    key() {
      return this.formData.key;
    },
  },
  methods: {
    ...mapMutations({
      closeModal,
    }),
    ...mapActions({
      changePipelineStatusAction,
      showToastAction,
    }),
    onClose() {
      this.closeModal(CONFIRM_ARCHIVE_PIPELINE_MODAL + this.pipelineId);
    },
    async onConfirm() {
      try {
        this.showToastAction({
          key: changePipelineStatusAction,
          title: this.toastTitle[this.key]['progress'],
          type: TOAST_TYPE_ENUM.PROGRESS,
          duration: 0,
        });
        await this.changePipelineStatusAction({
          pipelineId: this.pipelineId,
          status: this.key,
        });
        this.showToastAction({
          key: changePipelineStatusAction,
          title: this.toastTitle[this.key]['success'],
          type: TOAST_TYPE_ENUM.SUCCESS,
        });
        this.$emit('save');
      } catch (err) {
        this.showToastAction({
          key: changePipelineStatusAction,
          title: 'An error occurred',
          description:
            'Please try again or contact support if the issue persists.',
          type: TOAST_TYPE_ENUM.ERROR,
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
